import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import EmptyState from '../../components/EmptyState';
import CreatePostButton from '../../post/CreatePostButton';
import useIsEditingInPlace from '../../utils/useIsEditingInPlace';
import topicPolicyCheck, { TopicPolicyAction } from '../topicPolicyCheck';
import { useAllTopicMap } from '../useAllTopics';

interface TopicPostsEmptyStateProps {
  topicId: string;
}

const TopicPostsEmptyState = ({ topicId }: TopicPostsEmptyStateProps) => {
  const [isEditing] = useIsEditingInPlace();

  const topic = useAllTopicMap()[topicId];
  const currentUser = useAppSelector((state) => state.session.user);

  if (!topic) {
    return null;
  }
  const canCreatePost =
    !isEditing &&
    topicPolicyCheck(TopicPolicyAction.EditPost, topic, currentUser);

  return (
    <EmptyState
      imageName="posts"
      title="No posts here…"
      message={
        canCreatePost
          ? 'Create a post or tag an existing post with this topic.'
          : 'Only topic owners can add posts to this topic.'
      }
      action={
        canCreatePost && (
          <CreatePostButton size="large" variant="secondary" topicId={topic.id}>
            Create a post
          </CreatePostButton>
        )
      }
    />
  );
};

export default TopicPostsEmptyState;
